export const projects = [
  {
    title: "Self-Service Animal Movement Data Portal",
    subtitle: "Cellular Tracking Technologies",
    description:
      "Built React and JavaScript interfaces for a self-service data portal, giving clients the ability to explore and analyze animal movement datasets independently.",
    link: "https://portal.ctt-iow.com/",
  },
  {
    title: "Distributed IoT Data Pipelines",
    subtitle: "Cellular Tracking Technologies",
    description:
      "Developed, tested, and deployed scalable Node.js data pipelines for Raspberry Pi-based remote IoT servers, enabling near-real-time ingestion from distributed field sensors.",
    link: "https://celltracktech.com/",
  },
  {
    title: "Flutter Billing Portal",
    subtitle: "Cellular Tracking Technologies",
    description:
      "Built a billing platform integrating Flutter, the QuickBooks RESTful API, and MongoDB, from schema design through end-to-end delivery.",
    link: "https://celltracktech.com/",
  },
  {
    title: "Alexa Skill for Live Bird Song Audio",
    subtitle: "Cellular Tracking Technologies",
    description:
      "Developed an Alexa Skill to livestream bird song audio using a CRUD-style API, tested and validated with Postman.",
    link: "https://celltracktech.com/",
  },
];

export const publications = [
  {
    title:
      "Anthropogenic noise alters parental behavior and nestling developmental patterns, but not fledging condition.",
    subtitle: "Behavioral Ecology",
    description:
      "Examined how anthropogenic noise affected parental care behavior and nestling development in Eastern Bluebirds (Sialia sialis).",
    link: "http://dx.doi.org/10.1093/beheco/arab015",
  },
  {
    title:
      "Environmental conditions lead to shifts in individual communication, which can cause cascading effects on soundscape composition.",
    subtitle: "Ecology and Evolution",
    description:
      "Examined how aridity levels, which increased sound attenuation and led to reduced water resources, affected individual vocal behaviors and the entire vocal communication system of a population using an agent-based model.",
    link: "https://onlinelibrary.wiley.com/doi/full/10.1002/ece3.9359",
  },
  {
    title:
      "It's not the heat, it's the aridity: avian song activity and species diversity at the community level have consistent, negative responses to increasing aridity.",
    subtitle: "Dissertation research",
    description:
      "Examined if aridity affected vocal detectability and if supplemental water alleviated the cost of vocalizing under arid conditions.",
    link: "https://meelyn-pandit.github.io/",
  },
];

export const research_interests = [
  {
    quote:
      "Understanding how increasing aridity due to climate change will affect individual avian vocal behavior, and how that will cascade into changes in the avian community soundscape.",
    image: "./sswma_landscape.JPEG",
  },
  {
    quote:
      "Understanding the limits of behavioral flexibility in responding to extreme climate change conditions and anthropogenic disturbance.",
    image: "./pabu_singing.jpg",
  },
];

export const skills = [
  "JavaScript / TypeScript",
  "Python",
  "React",
  "Node.js",
  "Flutter",
  "SQL / PostgreSQL",
  "MongoDB",
  "AWS S3",
  "TensorFlow",
  "R",
  "Git / GitHub",
  "C++",
];
